import React from 'react'

import { getAspectRatioPadding } from './utils/getAspectRatioPadding'

import { TIconProps } from './iconProps'

const IconYoutube: React.FC<TIconProps> = (props) => {
  return (
    <div style={props.style} className={`select-none ${props.className || 'w-24'}`} onClick={props.onClick}>
      <div className="relative h-0" style={getAspectRatioPadding(props.aspectRatio)}>
        <svg xmlns="http://www.w3.org/2000/svg" className="w-full h-full left-0 top-0 absolute" viewBox="0 0 48 48">
          <path
            fill="currentColor"
            d="M43.164 14.4c-.46-1.732-1.815-3.096-3.536-3.559C36.508 10 24 10 24 10s-12.508 0-15.628.841c-1.72.463-3.076 1.827-3.536 3.56C4 17.54 4 24.09 4 24.09s0 6.55.836 9.69c.46 1.732 1.815 3.096 3.536 3.56 3.12.84 15.628.84 15.628.84s12.508 0 15.628-.84c1.72-.464 3.076-1.828 3.536-3.56.836-3.14.836-9.69.836-9.69s0-6.55-.836-9.69"
          />
          <path fill="#FFFFFF" d="M19.909 30.038L30.364 24.091 19.909 18.143 19.909 30.038" />
        </svg>
      </div>
    </div>
  )
}
export default IconYoutube
